/* template */
<template minapp="mpx" xlang="wxml"><es-popup :show="(show)" :position="(position)" @close="close" :class='[$attrs["custom-class"]]'><div :style="[(customStyle)] | transRpxStyle" class="drawer-container"><div class="drawer-main custom-main"><slot/></div><div :style="[(navbarStyle)] | transRpxStyle" class="header"><div><slot name="left" v-if="(defaultNavLeft)"/><div class="left-view" v-else></div></div><div class="drawer-title">{{ title }}</div><mpx-view @tap="close"><es-icon size="24" name="close-filled"></es-icon></mpx-view></div></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"meb3fdc9e"}'>
  .drawer-container {
    // width: 100vw;
    height: 50vh;
    // margin-top: 50vh;
    background: #ffffff;
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
    position: relative;

    .header {
      position: fixed;
      width: 100%
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
    }
  }

  .es-navbar {
    background-color: #ffffff;
    flex: 0 0 60px;
    width: 100%;
  }

  .left-view {
    width: 24px;
    height: 20px;
  }

  .drawer-title {
    font-size: 18px;
    font-weight: 700;
  }

  .drawer-main {
    flex: 1;
    overflow: auto;
    width: 100%;
    padding-top: 60px;
  }
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "meb3fdc9e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexeb3fdc9e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["meb3fdc9e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexeb3fdc9e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-popup':getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-navbar':getComponent(require("../navbar/index.mpx?isComponent&outputPath=components%2Findex15de91ba%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
